require('./brokerWarrantsHeader.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter, Prompt } = require('react-router-dom');
const moment = require('moment');

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const StockExchangeIndexVariation = require('components/broker/commons/stockExchange/stockExchangeIndexVariation');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKLink } = require('commonsComponents/OKLink');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const Flag = require('components/broker/commons/flag/flag');

// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerMiFIDUSPersonButton = require('mifid/components/brokerMiFIDUSPersonButton/brokerMiFIDUSPersonButton');
const { BrokerClientWarningModal } = require('components/broker/commons/brokerClientWarningModal/brokerClientWarningModal');
const BrokerProductUserInfo = require('components/broker/brokerProductUserInfo/brokerProductUserInfo');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const BrokerRiskIndicator = require('components/broker/brokerRiskIndicator/brokerRiskIndicator');


// @actions
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');

// @ helpers
const { formatAmount, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const headerHelper = require('components/broker/brokerProductHeaders/brokerProductHeaderHelper');
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @constants
const MICCODE_CONVERSION = require('constants/miccodes');
const {
    BROKER_WARRANTS_CALL_VALUE,
    BROKER_WARRANTS_PUT_VALUE,
    BROKER_WARRANTS_PUT_TEXT,
    BROKER_WARRANTS_CALL_TEXT,
    MYPROFILE_BROKER_EXPLORE_URL,
    BROKER_TYPE_STOCKS_NEW_DECIMALS,
    MYPROFILE_BROKER_ERROR_URL,
    BROKER_ORDER_CONDITION_TYPE_VALUE_PERCENTAGE_UNIT,
    BROKER_LARGE_FLAG_SIZE
} = require('constants/index');
const { NOT_ALLOWED_WEALTH_PRODUCT_NAME_FROM_CATALOGUE_COUNTRIES } = require('constants/flagBasedFeatures');
const language = getLanguage();

class BrokerWarrantsHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nextLocation: null,
            isBlockingRouteChange: false,
        };

        this.buildBuyUrl = this.buildBuyUrl.bind(this);
        this.createHeadersHeader = this.createHeadersHeader.bind(this);
        this.createHeadersDetails = this.createHeadersDetails.bind(this);
        this.createHeadersLastQuoteSection = this.createHeadersLastQuoteSection.bind(this);
        this.createHeadersDemandOfferSection = this.createHeadersDemandOfferSection.bind(this);
        this.createHeadersUnderlyingSection = this.createHeadersUnderlyingSection.bind(this);
        this.createBottomButtons = this.createBottomButtons.bind(this);
        this.handleGoToBuyProduct = this.handleGoToBuyProduct.bind(this);
        this.handleGoToSellProduct = this.handleGoToSellProduct.bind(this);
        this.handleOnToggle = this.handleOnToggle.bind(this);
    }

    componentDidMount() {
        const { immMyInvestments } = this.props;
        if (!immMyInvestments.get('fetchSuccess') && !immMyInvestments.get('isFetching') && !immMyInvestments.get('errorReceived')) {
            this.props.fetchMyInvestments();
        }
    }

    buildAmountCurrency(amount, currency) {
        return (
            <span>
                <span>{amount} </span>
                <span>{currency}</span>
            </span>
        );
    }

    buildBrokerProductUserInfo(possessions) {
        const { noBottomButtons, immMyInvestments } = this.props;
        if (immMyInvestments.get('fetchSuccess')) {
            return (
                <BrokerProductUserInfo
                    noBottomButtons={noBottomButtons}
                    immStock={possessions}
                />
            );
        }
    }

    buildBuyUrl() {
        const isin = this.props.isin;
        const iso = this.props.iso;
        return `/myprofile/broker/warrantsBuy/${isin}/${iso}`;
    }

    buildErrorSection(PREFIX) {
        const { productFile } = this.props;
        const error = productFile.get('error') || {};
        const isEmptyResponse = !error.error && !error.errorDescription;

        let primaryText;
        let secondaryText;
        let button;

        if (isEmptyResponse) {
            primaryText = formatText(`${PREFIX}NoInformationForProduct`);
            secondaryText = formatText(`${PREFIX}ContactUsToResolveIssue`);
            button = (
                <OKLink modifier="emphasize" to={MYPROFILE_BROKER_EXPLORE_URL}>
                    <FormattedText value={`${PREFIX}GoBack`} />
                </OKLink>
            );
        } else {
            primaryText = formatText(`${PREFIX}LostConnectionFirstLine`);
            button = (
                <OKButton onClick={this.props.handleUpdate}>
                    <FormattedText value={`${PREFIX}Retry`} />
                </OKButton>
            );
        }

        return (
            <EmptyState primaryText={primaryText} secondaryText={secondaryText} button={button} iconType="nointernet-wealth" />
        );
    }

    buildLoadingSection() {
        return <LoadingSection />;
    }

    getTitlesQuantity() {
        const { immMyInvestments, productFile } = this.props;
        const immStocks = immMyInvestments.getIn(['products', 'warrants', 'stocks'], []);
        let titlesQuantity = 0;
        let titlesValuation = 0.0;
        let possessionsCurrency;

        immStocks.forEach(immStock => {
            if (immStock.get('isin') === productFile.get('isinCode') && immStock.get('iso') === productFile.get('micCode')) {
                possessionsCurrency = possessionsCurrency ? possessionsCurrency : immStock.get('totalValueCurrency');
                titlesQuantity += immStock.get('shares', 0);
                titlesValuation += immStock.get('totalValue', 0.0);
                if (immStock.getIn(['unconsolidatedOperations', 'hasUnconsolidatedOperations'])) {
                    titlesQuantity += immStock.getIn(['unconsolidatedOperations', 'shares'], 0);
                    titlesValuation += immStock.getIn(['unconsolidatedOperations', 'totalValue'], 0.0);
                }
            }
        });

        return {
            titlesQuantity,
            titlesValuation,
            possessionsCurrency
        }
    }

    buildPossessions(PREFIX) {
        const {
            titlesQuantity,
            titlesValuation,
            possessionsCurrency
        } = this.getTitlesQuantity();

        const walletLabel = formatText(`${PREFIX}WalletLabel`);
        const titlesLabel = headerHelper.getTitleLabel(titlesQuantity);

        const valuationObject = {
            amount: titlesValuation,
            currency: possessionsCurrency
        };
        const plainAmountObject = getPlainAmountObject(valuationObject);
        const balanceSymbol = (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
        );

        if (!titlesQuantity) {
            return null;
        }

        return (
            <span className="broker-warrants-header__wallet">
                {walletLabel}: {titlesQuantity} {titlesLabel} | {balanceSymbol}
            </span>
        );
    }

    createBottomButtons(PREFIX, noButtons) {
        const buyLabel = formatText(`${PREFIX}BuyLabel`);
        const sellLabel = formatText(`${PREFIX}SellLabel`);
        const { immMyInvestments, productFile } = this.props;

        const warrants = immMyInvestments ? immMyInvestments.getIn(['products', 'warrants', 'stocks'], []) : {};
        const warrant = warrants.find(warrant => {
            return (
                warrant.get('isin') === productFile.get('isinCode') &&
                warrant.get('iso') === productFile.get('micCode')
            );
        });

        const titlesQuantity = warrant ? warrant.get('shares') : '';
        let sellButton;

        if (titlesQuantity) {
            sellButton = (
                <div className="broker-warrants-header__button-container">
                    <OKButton modifier="ghost" onClick={this.handleGoToSellProduct}>
                        {sellLabel}
                    </OKButton>
                </div>
            );
        }

        return !noButtons
            ? <div className="row">
                <div className="col-lg-offset-8 col-lg-4">
                    <div className="broker-warrants-header__buttons">
                        {sellButton}
                        <div className="broker-warrants-header__button-container">
                            <BrokerMiFIDUSPersonButton
                                modifier="secondary"
                                onClick={this.handleGoToBuyProduct}
                                isinId={this.props.isin}
                                marketId={this.props.iso}
                            >
                                {buyLabel}
                            </BrokerMiFIDUSPersonButton>
                        </div>
                    </div>
                </div>
            </div>
            : undefined;
    }

    createHeadersDemandOfferSection(PREFIX, productFile) {
        const demandOfferQuoteTitle = formatText(`${PREFIX}QuoteTitleLabel`);
        const demandVolumeLabel = formatText(`${PREFIX}DemandVolumeLabel`).split(' ');
        const demandPriceLabel = formatText(`${PREFIX}DemandPriceLabel`);
        const offerPriceLabel = formatText(`${PREFIX}OfferPriceLabel`);
        const offerVolumeLabel = formatText(`${PREFIX}OfferVolumeLabel`).split(' ');

        // @hardcoded -- we still have to obtain this warrant's info from a service
        const warrantsDemandVolume = productFile.get('warrant').get('demandVolume');
        const warrantsDemandPrice = productFile.get('warrant').get('demandPrice');
        const warrantsOfferPrice = productFile.get('warrant').get('offerPrice');
        const warrantsOfferVolume = productFile.get('warrant').get('offerVolume');

        const currencySymbol = headerHelper.getCurrencySimbol(this.props.productFile.get('currency'));
        const volumeBuyAmountLabel = headerHelper.getTitleLabel(productFile.get('buyAmount'));
        const volumeSellAmountlabel = headerHelper.getTitleLabel(productFile.get('sellAmount'));

        return (
            <div className="col-lg-5 broker-warrants-header__warrants-demand-offer-info">
                <div className="broker-warrants-header__warrants-demand-offer-title">
                    {demandOfferQuoteTitle}
                </div>
                <div className="broker-warrants-header__warrants-demand-offer-cell">
                    <div className="broker-warrants-header__warrant-info-wrapper">
                        <span className="broker-warrants-header__warrant-info">
                            {demandVolumeLabel[0]}
                            <br />
                            {demandVolumeLabel[1]}
                        </span>
                        <OKTooltip
                            content={`${PREFIX}DemandVolumeLabelTooltip`}
                            offset={[0, -10]}
                        />
                    </div>
                    <span className="broker-warrants-header__warrant-value">
                        {formatAmount(warrantsDemandVolume, undefined, 0)} {volumeBuyAmountLabel}
                    </span>
                </div>
                <div className="broker-warrants-header__warrants-demand-offer-cell">
                    <div className="broker-warrants-header__warrant-info-wrapper">
                        <span className="broker-warrants-header__warrant-info">
                            {demandPriceLabel}
                        </span>
                        <OKTooltip
                            content={`${PREFIX}DemandPriceLabelTooltip`}
                            offset={[0, -10]}
                        />
                    </div>
                    <span className="broker-warrants-header__warrant-value">
                        {formatAmount(warrantsDemandPrice, undefined, BROKER_TYPE_STOCKS_NEW_DECIMALS)} {currencySymbol}
                    </span>
                </div>
                <div className="broker-warrants-header__warrants-demand-offer-cell">
                    <span className="broker-warrants-header__warrant-info-wrapper">
                        <span className="broker-warrants-header__warrant-info">
                            {offerPriceLabel}
                        </span>
                        <OKTooltip
                            content={`${PREFIX}OfferPriceLabelTooltip`}
                            offset={[0, -10]}
                        />
                    </span>
                    <span className="broker-warrants-header__warrant-value">
                        {formatAmount(warrantsOfferPrice, undefined, BROKER_TYPE_STOCKS_NEW_DECIMALS)} {currencySymbol}
                    </span>
                </div>
                <div className="broker-warrants-header__warrants-demand-offer-cell">
                    <div className="broker-warrants-header__warrant-info-wrapper">
                        <span className="broker-warrants-header__warrant-info">
                            {offerVolumeLabel[0]}
                            <br />
                            {offerVolumeLabel[1]}
                        </span>
                        <OKTooltip
                            content={`${PREFIX}OfferVolumeLabelTooltip`}
                            offset={[0, -10]}
                        />
                    </div>
                    <span className="broker-warrants-header__warrant-value">
                        {formatAmount(warrantsOfferVolume, 'es', 0)} {volumeSellAmountlabel}
                    </span>
                </div>
            </div>
        );
    }

    createHeadersDetails(PREFIX, productFile) {
        const underlyingLabel = formatText(`${PREFIX}UnderlyingName`);
        const emitterLabel = formatText(`${PREFIX}Emitter`);
        const activeTypeLabel = formatText(`${PREFIX}ActiveType`);
        const typeLabel = formatText(`${PREFIX}WarrantType`);
        const expirationDateLabel = formatText(`${PREFIX}ExpirationDate`);
        const excercisePriceLabel = formatText(`${PREFIX}ExcercisePrice`);
        const currencyLabel = formatText(`${PREFIX}Currency`);
        const marketLabel = formatText(`${PREFIX}Market`);

        const underlyingName = productFile.get('warrant').get('underlyingName');
        const emitter = productFile.get('warrant').get('issuerName');
        const activeType = productFile.get('warrant').get('activeType');
        const notAvailableText = formatText('broker-searchResultsNotAvailableData');
        let type;
        switch (productFile.get('warrant').get('warrantType')) {
            case BROKER_WARRANTS_CALL_VALUE:
                type = BROKER_WARRANTS_CALL_TEXT;
                break;
            case BROKER_WARRANTS_PUT_VALUE:
                type = BROKER_WARRANTS_PUT_TEXT;
                break;
            default:
                type = notAvailableText;
                break;
        }
        const expirationDate = productFile.get('warrant').get('expirationDate');
        const excercisePrice = formatAmount(productFile.get('warrant').get('excercisePrice'), getLanguage(), 3);
        const excerciseCurrency = productFile.get('productValue').get('currency');
        const excercisePriceObject = this.buildAmountCurrency(excercisePrice, excerciseCurrency);
        const currency = productFile.get('currency');
        const market = productFile.get('warrant').get('marketplace');

        return (
            <div className="broker-warrants-header__warrant-details">
                <div className="broker-warrants-header__emitter-active-type">
                    <span className="broker-warrants-header__lowercase-label">
                        {underlyingLabel}:
                    </span>
                    <span className="broker-warrants-header__detail-content">
                        {underlyingName}
                    </span>
                    <span className="broker-warrants-header__lowercase-label">
                        {emitterLabel}:
                    </span>
                    <span className="broker-warrants-header__detail-content">
                        {emitter}
                    </span>
                    <span className="broker-warrants-header__lowercase-label">
                        {activeTypeLabel}:
                    </span>
                    <span className="broker-warrants-header__detail-content">
                        {activeType}
                    </span>
                    <span className="broker-warrants-header__lowercase-label">
                        {typeLabel}:
                    </span>
                    <span className="broker-warrants-header__detail-content">
                        {type}
                    </span>
                </div>
                <div className="broker-warrants-header__date-price-market">
                    <span className="broker-warrants-header__uppercase-label">
                        {expirationDateLabel.toUpperCase()}:
                    </span>
                    <span className="broker-warrants-header__detail-content">
                        {expirationDate}
                    </span>
                    <span className="broker-warrants-header__uppercase-label">
                        {excercisePriceLabel.toUpperCase()}:
                    </span>
                    <span className="broker-warrants-header__detail-content">
                        {excercisePriceObject}
                    </span>
                    <span className="broker-warrants-header__uppercase-label">
                        {currencyLabel.toUpperCase()}:
                    </span>
                    <span className="broker-warrants-header__detail-content">
                        {currency}
                    </span>
                    <span className="broker-warrants-header__uppercase-label">
                        {marketLabel.toUpperCase()}:
                    </span>
                    <span className="broker-warrants-header__detail-content">
                        {market}
                    </span>
                </div>
            </div>
        );
    }

    createHeadersHeader(PREFIX, productFile, warrantFile) {
        const { immFlagBasedFeatures } = this.props
        const isinCodeLabel = formatText(`${PREFIX}IsinCodeLabel`).toUpperCase();
        const quoteLabel = formatText(`${PREFIX}QuoteWarrantsLabel`);
        const allowCatalogueNames = immFlagBasedFeatures.get(NOT_ALLOWED_WEALTH_PRODUCT_NAME_FROM_CATALOGUE_COUNTRIES);
        const CompanyName = allowCatalogueNames && warrantFile ? warrantFile.get('stockName') : productFile.get('companyName');
        //const IsinCode = productFile.get('isinCode');
        const isinCode = productFile.get('isinCode');
        const isoCode = productFile.get('micCode');
        const ValueObject = productFile.get('productValue').set('decimalsLength', BROKER_TYPE_STOCKS_NEW_DECIMALS);
        const VariationPts = productFile.get('indexValue').get('variation');
        const VariationPct = productFile.get('indexValue').get('percentage');
        const target = (
            <i className="broker-warrants-header__icon-notification icon icon-notificaciones" />
        );
        const targetEl = React.cloneElement(target, { onClick: this.handleOnToggle });
        const plainAmountObject = getPlainAmountObject(ValueObject);
        let marketCode, flag;

        const market = MICCODE_CONVERSION.find(market => market.MIC == isoCode);
        marketCode = market ? ` ${market.CITY}, ${market.ISO_COUNTRY_CODE} ` : '';
        if (market) {
            flag = <Flag countryCode={market.ISO_COUNTRY_CODE} pixelsSize={BROKER_LARGE_FLAG_SIZE} />
        }

        return (
            <div className="broker-warrants-header__header row">
                <div className="col-lg-12 broker-warrants-header__company">
                    <div className="broker-warrants-header__company-header">
                        <h2 className="broker-warrants-header__company-name">
                            {CompanyName}
                        </h2>
                    </div>
                    <span className="broker-warrants-header__isin">
                        {isinCodeLabel}: {isinCode}
                        {' - '}
                        {flag}
                        {marketCode}
                    </span>
                </div>
                <div className="col-lg-12 ">
                    <div className="broker-warrants-header__risk-indicator">
                        <BrokerRiskIndicator
                            riskValue={7}
                            textContent="warrants-riskIndicatorWarrants_content"
                            productType="Warrants"
                        />
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="broker-warrants-header__quote-box">
                        <span className="broker-warrants-header__quote">
                            {quoteLabel}
                        </span>
                        <div className="broker-warrants-header__product-quote-container">
                            <div className="broker-warrants-header__product-value-container">
                                <OneLineSymbolAmount
                                    amountObject={plainAmountObject}
                                    className="broker-warrants-header__product-value"
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                                />
                                {targetEl}
                            </div>
                            <div className="broker-warrants-header__index-box">
                                <span className="broker-warrants-header__index-value">
                                    <StockExchangeIndexVariation
                                        variationPts={formatAmount(VariationPts, undefined, BROKER_TYPE_STOCKS_NEW_DECIMALS)}
                                        variationPerc={formatAmount(VariationPct)}
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    createHeadersLastQuoteSection(PREFIX, productFile) {
        const dateFormat = formatText(`${PREFIX}DateFormat`);
        const LastDate = productFile.get('updatePriceDate');
        const LastTime = productFile.get('updatePriceTime');

        const possessionsSection = this.buildPossessions(PREFIX);
        const hasPossessions = possessionsSection ?
            'broker-warrants-header__last-price-container' : 'broker-warrants-header__last-price-container-not-possesions'

        let formattedLastPriceDate = '';
        let lastPriceLabelValue = '';
        if (LastDate) {
            formattedLastPriceDate = moment(LastDate, 'DD/MM/YYYY')
                .format(dateFormat)
                .replace('.', '');
        }

        if (!!LastDate && !!LastTime) {
            lastPriceLabelValue = (
                <FormattedTextWithComponents
                    value={`${PREFIX}QuotationLabel`}
                    injectedComponents={[LastTime, formattedLastPriceDate]}
                    className="broker-warrants-header__last-price-date"
                />)
        }

        return (
            <div className="broker-warrants-header__wallet-last-price-section row">
                {
                    possessionsSection && (
                        <div className="col-lg-6">
                            {possessionsSection}
                        </div>
                    )
                }
                <div className="col-lg-6">
                    <div className={hasPossessions}>
                        {lastPriceLabelValue}
                    </div>
                </div>
            </div>
        );
    }

    createHeadersUnderlyingSection(PREFIX, productFile) {
        const underlyingQuoteTitle = formatText(`${PREFIX}UndelyingQuoteTitleLabel`);
        const lastQuoteLabel = formatText(`${PREFIX}LastQuoteLabel`);
        const quoteVariationLabel = formatText(`${PREFIX}QuoteVariationLabel`);
        const maximumValueLabel = formatText(`${PREFIX}MaximumValueLabel`);
        const minimumValueLabel = formatText(`${PREFIX}MinimumValueLabel`);
        const openingValueLabel = formatText(`${PREFIX}OpeningValueLabel`);
        const quoteDateLabel = formatText(`${PREFIX}QuoteDateLabel`);
        const quoteTimeLabel = formatText(`${PREFIX}QuoteTimeLabel`);

        const underlyingLastQuote = productFile.get('warrant').get('underlying').get('last');
        const underlyingVariation = productFile
            .get('warrant')
            .get('underlying')
            .get('variationPerc');
        const underlyingMaxValue = productFile.get('warrant').get('underlying').get('max');
        const underlyingMinValue = productFile.get('warrant').get('underlying').get('min');
        const underlyingOpeningValue = productFile.get('warrant').get('underlying').get('open');
        const underlyingQuoteDate = productFile.get('warrant').get('underlying').get('date');
        const underlyingQuoteTime = productFile.get('warrant').get('underlying').get('time');

        const currencySymbol = headerHelper.getCurrencySimbol(this.props.productFile.get('currency'));

        return (
            <div className="col-lg-7 broker-warrants-header__warrants-underlying-quote-info">
                <div className="broker-warrants-header__warrants-underlying-quote-title">
                    {underlyingQuoteTitle}
                </div>
                <div className="broker-warrants-header__warrants-underlying-quote-info-cell">
                    <span className="broker-warrants-header__warrant-info">
                        {lastQuoteLabel}
                    </span>
                    <span className="broker-warrants-header__warrant-value">
                        {formatAmount(underlyingLastQuote, undefined, BROKER_TYPE_STOCKS_NEW_DECIMALS)} {currencySymbol}
                    </span>
                </div>
                <div className="broker-warrants-header__warrants-underlying-quote-info-cell">
                    <span className="broker-warrants-header__warrant-info">
                        {quoteVariationLabel}
                    </span>
                    <span className="broker-warrants-header__warrant-value">
                        {formatAmount(underlyingVariation)} {BROKER_ORDER_CONDITION_TYPE_VALUE_PERCENTAGE_UNIT}
                    </span>
                </div>
                <div className="broker-warrants-header__warrants-underlying-quote-info-cell">
                    <span className="broker-warrants-header__warrant-info">
                        {maximumValueLabel}
                    </span>
                    <span className="broker-warrants-header__warrant-value">
                        {formatAmount(underlyingMaxValue, undefined, BROKER_TYPE_STOCKS_NEW_DECIMALS)} {currencySymbol}
                    </span>
                </div>
                <div className="broker-warrants-header__warrants-underlying-quote-info-cell">
                    <span className="broker-warrants-header__warrant-info">
                        {minimumValueLabel}
                    </span>
                    <span className="broker-warrants-header__warrant-value">
                        {formatAmount(underlyingMinValue, undefined, BROKER_TYPE_STOCKS_NEW_DECIMALS)} {currencySymbol}
                    </span>
                </div>
                <div className="broker-warrants-header__warrants-underlying-quote-info-cell">
                    <span className="broker-warrants-header__warrant-info">
                        {openingValueLabel}
                    </span>
                    <span className="broker-warrants-header__warrant-value">
                        {formatAmount(underlyingOpeningValue, undefined, BROKER_TYPE_STOCKS_NEW_DECIMALS)} {currencySymbol}
                    </span>
                </div>
                <div className="broker-warrants-header__warrants-underlying-quote-info-cell">
                    <span className="broker-warrants-header__warrant-info">
                        {quoteDateLabel}
                    </span>
                    <span className="broker-warrants-header__warrant-value">
                        {underlyingQuoteDate}
                    </span>
                </div>
                <div className="broker-warrants-header__warrants-underlying-quote-info-cell">
                    <span className="broker-warrants-header__warrant-info">
                        {quoteTimeLabel}
                    </span>
                    <span className="broker-warrants-header__warrant-value">
                        {underlyingQuoteTime}
                    </span>
                </div>
            </div>
        );
    }

    handleGoToBuyProduct() {
        const immbrokerClientWarningModal = this.props.immbrokerClientWarningModal;
        const showClientWarningModal = this.props.showClientWarningModal;
        const clientPersonalInfoUpdated = immbrokerClientWarningModal.get('clientPersonalInfoUpdated');
        const isFetching = immbrokerClientWarningModal.get('isFetching');
        const isFetched = immbrokerClientWarningModal.get('isFetched');

        const buyLink = this.buildBuyUrl();
        this.props.fireTaggingBuyButton(this.props.isin)
        if (isFetched && !isFetching) {
            if (!clientPersonalInfoUpdated) {
                showClientWarningModal(this.props.history);
                this.setState({
                    nextLocation: buyLink,
                    isBlockingRouteChange: true
                });
            } else {
                this.props.history.push(buyLink);
            }
        } else if (!isFetched && !isFetching) {
            this.props.history.push(MYPROFILE_BROKER_ERROR_URL);
        }
        window.modalInstance = this;
    }

    handleGoToSellProduct() {
        const { isin, iso, immMyInvestments } = this.props;

        if (isin && iso) {
            const warrants = immMyInvestments ? immMyInvestments.getIn(['products', 'warrants', 'stocks'], []) : {};
            const warrant = warrants.find(warrants => {
                return warrants.get('isin') === isin && warrants.get('iso') === iso;
            });

            const emisionCode = warrant ? warrant.get('emisionCode') : "";
            const valueCode = warrant ? warrant.get('valueCode') : "";
            const sellUrl = `/myprofile/broker/warrantsSell/${isin}/${iso}/${emisionCode}/${valueCode}`

            const immbrokerClientWarningModal = this.props.immbrokerClientWarningModal;
            const showClientWarningModal = this.props.showClientWarningModal;
            const clientPersonalInfoUpdated = immbrokerClientWarningModal.get('clientPersonalInfoUpdated');
            const isFetching = immbrokerClientWarningModal.get('isFetching');
            const isFetched = immbrokerClientWarningModal.get('isFetched');

            if (isFetched && !isFetching) {
                if (!clientPersonalInfoUpdated) {
                    showClientWarningModal();
                    this.setState({
                        nextLocation: sellUrl,
                        isBlockingRouteChange: true
                    });
                } else {
                    this.props.history.push(sellUrl);
                }
            } else if (!isFetched && !isFetching) {
                this.props.history.push(MYPROFILE_BROKER_ERROR_URL);
            }
            window.modalInstance = this;
        }
    }

    handleOnToggle() {
        this.props.history.push('/myprofile/broker/alertsConfig/');
    }

    render() {
        const { productFile, noBottomButtons, warrantFile } = this.props;
        const WARRANTS_PREFIX = 'broker-warrants';

        const headersHeader = this.createHeadersHeader(WARRANTS_PREFIX, productFile, warrantFile);
        /*const stocks = immMyInvestments.getIn(['products', 'warrants', 'stocks']);
        const warrants = stocks.filter(stock => {
            return stock.get('isin') === productFile.get('isinCode') && stock.get('iso') === productFile.get('micCode');
        });

        const headersHeader = this.createHeadersHeader(WARRANTS_PREFIX, productFile, warrants.first());*/
        const headersDetails = this.createHeadersDetails(WARRANTS_PREFIX, productFile );
        const headersLastPriceSection = this.createHeadersLastQuoteSection(
            WARRANTS_PREFIX,
            productFile
        );

        const headersDemandOfferSection = this.createHeadersDemandOfferSection(
            WARRANTS_PREFIX,
            productFile
        );
        const headersUnderlyingSection = this.createHeadersUnderlyingSection(
            WARRANTS_PREFIX,
            productFile
        );

        const possessions = productFile.get('possessions');
        const bottomButtons = this.createBottomButtons(
            WARRANTS_PREFIX,
            noBottomButtons,
            possessions
        );

        const headersValuesSection = (
            <div className="row">
                <div className="col-lg-12">
                    <div className="clearfix broker-warrants-header__warrants-values">
                        {headersDemandOfferSection}
                        {headersUnderlyingSection}
                    </div>
                </div>
            </div>
        );

        let content;
        //const brokerProductUserInfo = this.buildBrokerProductUserInfo(warrants);

        if (productFile.get('error')) {
            content = this.buildErrorSection(WARRANTS_PREFIX);
        } else if (!productFile.get('isFetched') || (warrantFile && !warrantFile.get('fetchedCatalogue'))) {
            content = this.buildLoadingSection();
        } else {
            content = [
                headersHeader,
                headersLastPriceSection,
                headersDetails,
                headersValuesSection,
                //brokerProductUserInfo,
                bottomButtons
            ];
        }

        return (
            <React.Fragment>
                <Prompt message={() => false} when={this.state.isBlockingRouteChange} />
                <ContentBox
                    id="brokerStocksLikeHeader"
                    customClassName="broker-warrants-header broker-warrants-header--warrants"
                >
                    <BrokerClientWarningModal
                        nextLocation={this.state.nextLocation}
                        routerHookCallback={() => {
                            this.setState({ isBlockingRouteChange: false });
                        }}
                    />
                    {content}
                </ContentBox>
            </React.Fragment>
        );
    }
}

BrokerWarrantsHeader.propTypes = {
    productFile: PropTypes.object,
    history: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    isin: PropTypes.string,
    iso: PropTypes.string,
    handleUpdate: PropTypes.func,
    noBottomButtons: PropTypes.bool,
    immbrokerClientWarningModal: PropTypes.object,
    showClientWarningModal: PropTypes.func,
    fetchMyInvestments: PropTypes.func,
    fireTaggingBuyButton: PropTypes.func,
    warrantFile: PropTypes.object,
};

module.exports.BrokerWarrantsHeader = connect(
    state => ({
        immMyInvestments: state.brokerMyInvestments,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        fetchMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments
    }
)(withRouter(BrokerWarrantsHeader));
